export default [
    {
        path: '/sms',
        name: 'sms',
        component: () => import('../views/Sms.vue'),
        meta: {
            accountSelect: {
                disabled: false,
                showParentAccounts: false,
            },
            header: {
                account: true,
                notification: true,
                search: true,
                settings: true,
            },
            layout: {
                contentHeader: false,
            },
            fixedContent: true,
            saveInUrl: ['accountId'],
        },
    },
];
